import drawerStyles from "../../styles/drawer.module.css";
import Overlay from "../UI/Overlay";
import IconButtonComponent from "../UI/buttons/IconButton";
import { ReactComponent as CloseIcon } from "../../assets/icons/x_black.svg";
import labels from "../../utils/labels";

const Drawer = ({
  children,
  onClose,
  heading,
}: {
  children: React.ReactNode | React.ReactNode[];
  onClose: () => void;
  heading: string;
}) => {
  return (
    <Overlay clickAway={onClose}>
      <div className={drawerStyles.drawer}>
        {heading && (
          <div className={drawerStyles.drawerHeading}>
            <h1 style={{ font: "var(--font-h1)" }}>{heading}</h1>
            <IconButtonComponent
              id="drawer-close-button"
              icon={<CloseIcon />}
              onClick={onClose}
              ariaLabel={labels.closeDrawer}
            />
          </div>
        )}
        {children}
      </div>
    </Overlay>
  );
};

export default Drawer;
